export function isRequestGM(user, boutique) {
  return !!boutique && user?.role === "boutique_manager" &&
    (user.boutique_code || "").toUpperCase() === boutique.toUpperCase();
}
